import { themeVars } from '../theme/vars';
import { borderRadius, boxShadows, space } from '../tokens';
import { typography } from '../typography';
import { style, styleVariants } from '../layer.css';

export const alert = style([
  typography['bodyMd'],
  {
    color: themeVars.container.foreground.primary,
    padding: space.s12,
    borderRadius: borderRadius.r16,
    display: 'grid',

    gap: space.s16,
    outline: `1px solid ${themeVars.container.border.default}`,
    outlineOffset: '-1px',
  },
]);

export const alertElevated = style({
  boxShadow: boxShadows.default,
});

export const alertSize = styleVariants({
  small: {
    gridTemplateColumns: 'auto 1fr auto auto',
    alignItems: 'center',
  },
  medium: {
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'start',
  },
});

export const alertIcon = style({
  gridArea: 'icon',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const alertBody = style({
  gridArea: 'body',
});

export const alertActions = style({
  gridArea: 'actions',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: space.s12,

  selectors: {
    [`${alertSize.medium} &`]: {
      justifyContent: 'flex-end',
    },
  },
});

export const alertClose = style({
  gridArea: 'close',
});

export const alertVariant = styleVariants({
  default: {
    backgroundColor: themeVars.container.secondary.background.idle,
  },
  prominent: {
    backgroundColor: themeVars.container.prominent.background.idle,
  },
});
